module.exports = __webpack_public_path__ + "img/chara_line_4_white.9c35f07b.png";